import { Context, useContext, useMemo } from "react"
import { Voice } from "../../../typings/types"

export interface CanStoreVoiceFields {
    state: {
        fields: {
            sourceVoice: {
                value: string
            }
            targetVoice: {
                value: string
            }
        }
        voiceOptions: {
            source: Voice[]
            target: Voice[]
        }
    }
}

export const useNeuralVoiceCheck = <T extends CanStoreVoiceFields>(ctx: Context<T>) => {
    const context = useContext(ctx)

    function getVoiceBySelection(selection: "source" | "target"): Voice | undefined {
        const voiceField = `${selection}Voice` as "sourceVoice" | "targetVoice"
        const optionField = selection
        return context.state.voiceOptions[optionField].find(
            o => o.id === parseInt(context.state.fields[voiceField].value)
        )
    }

    function isUsingNeuralVoice(selection: "source" | "target"): boolean {
        const voice = getVoiceBySelection(selection)
        return voice?.engine === "neural"
    }
    const neural = useMemo(() => isUsingNeuralVoice("source") || isUsingNeuralVoice("target"), [
        context.state.fields.sourceVoice,
        context.state.fields.targetVoice
    ])

    return neural
}
